import { useContext } from 'react';

import { OnboardingActionContext } from './OnboardingContext';

export const useOnboardingActionContext = () => {
  const context = useContext(OnboardingActionContext);

  if (context === null) {
    throw new Error('useOnboardingActionContext must be used within a OnboardingProvider');
  }

  return context;
};
